import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';

import { FilterSvg } from '@assets';
import { IconButtonTooltip } from '@components';

interface IFilterButton {
  isDisabled: boolean;
}

export const FilterButton = ({ isDisabled }: IFilterButton) => {
  const theme = useTheme();

  return (
    <IconButtonTooltip
      disableInteractive
      title="common.grid.button.tooltip.search.orbit"
    >
      <Box component="span" sx={{ display: 'block' }}>
        <IconButton
          disableRipple
          sx={{
            width: '2.5rem',
            marginLeft: '0',
            height: '2.5rem',
            background: theme.palette.success.main,
            '&:hover': {
              boxShadow: theme.customShadows.iconButton,
            },
            '&.Mui-disabled': {
              background: theme.palette.success.main,
            },
          }}
          disabled={isDisabled}
          edge="start"
          type="submit"
        >
          <FilterSvg />
        </IconButton>
      </Box>
    </IconButtonTooltip>
  );
};
